// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export interface EmptySelectionState {}

function serializeSelectionState(_state: EmptySelectionState) {
  return '';
}

function unserializeSelectionState(_value: string | undefined): EmptySelectionState {
  return {};
}

export const emptySelectionState = {
  serializeSelectionState,
  // TODO can this be removed?
  unserializeSelectionState,
};
